import Vue from 'vue';
import Router from 'vue-router';
import MainLayout from './layouts/MainLayout.vue';
import Start from './views/Start.vue';
import Portfolio from './views/Portfolio.vue';
import Search from './views/Search.vue';
import CreateDocument from './views/CreateDocument.vue';
import EditDocument from './views/EditDocument.vue';
import CreateSlides from './views/CreateSlides.vue';
import ImportSie from './views/ImportSie.vue';
import EditSie from './views/EditSie.vue';
import SidebarCompany from './views/SidebarCompany.vue';
import Iconbar from './components/Iconbar.vue';
import SidebarPortfolio from './views/SidebarPortfolio.vue';
import CardOverview from './views/CardOverview.vue';
import CardOverviewPeople from './views/CardOverviewPeople.vue';
import CardTic from './views/CardTic.vue';
import CardAIQuestions from './views/CardAIQuestions.vue';
import CardCompassNew from './views/CardCompassNew.vue';
import CardCompassYearsNew from './views/CardCompassYearsNew.vue';
import CardCompassIndustryNew from './views/CardCompassIndustryNew.vue';
import CardProfitLoss from './views/CardProfitLoss.vue';
import CardCashFlow from './views/CardCashFlow.vue';
import CardValuation from './views/CardValuation.vue';
import CardBalance from './views/CardBalance.vue';
import CardSustainability from './views/CardSustainability.vue';
import CardSie from './views/CardSie.vue';
import CardDocuments from './views/CardDocuments.vue';
import CardSandbox from './views/CardSandbox.vue';
import user from '@/store/modules/user';
import axios from 'axios';
import PresentationScreen from '@/layouts/PresentationScreen.vue';
import PresentationPrint from '@/layouts/PresentationPrint.vue';
import Presentation from '@/presentation/Presentation.vue';
import CashflowPdf from '@/pdf/Cashflow.vue';
import ValuationPdf from '@/pdf/Valuation.vue';
import KycPdf from '@/pdf/KnowYourCustomer.vue';
import SandboxPdf from '@/pdf/Sandbox.vue';
import CashflowWebreport from '@/webreport/Cashflow.vue';
import SustainabilityPdf from '@/pdf/Sustainability.vue';
import CompanyPdf from '@/pdf/Company.vue';
import NotesPdf from '@/pdf/Notes.vue';
import AccountingPdf from '@/pdf/Accounting.vue';

import CardProfitLossNew from './views/CardProfitLossNew.vue';
import CardBalanceNew from './views/CardBalanceNew.vue';
import CardCashFlowNew from './views/CardCashFlowNew.vue';
import CardCashFlowAnalysis from './views/CardCashFlowAnalysis.vue';
import CardValuationAnalysis from './views/CardValuationAnalysis.vue';

import Quick from '@/presentations/Quick.vue';
import ShowSlides from '@/components/simpleSlide/components/ShowSlides.vue';
import ShowSlidesInfo from '@/components/simpleSlide/components/ShowSlidesInfo.vue';
import SidebarCreateDocument from '@/views/SidebarCreateDocument.vue';
import { enableCardTic } from '@/config';

const Root = () =>
    import(/* webpackChunkName: "root" */ `@/Root${
        process.env.VUE_APP_BRAND
    }.vue`);

const Valuation = () =>
    import(/* webpackChunkName: "c1" */ '@/presentations/Valuation.vue');
const Company = () =>
    import(/* webpackChunkName: "c1" */ `@/presentations/Company${
        process.env.VUE_APP_BRAND
    }.vue`);
const Competitors = () =>
    import(/* webpackChunkName: "c1" */ `@/presentations/Competitors${
        process.env.VUE_APP_BRAND
    }.vue`);
const YearReview = () =>
    import(/* webpackChunkName: "c1" */ `@/presentations/YearReview.vue`);

const ClosingMeeting = () =>
    import(/* webpackChunkName: "c2" */ '@/presentations/ClosingMeetingGT.vue');
const PreClosingMeeting = () =>
    import(/* webpackChunkName: "c2" */ '@/presentations/PreClosingMeetingGT.vue');
const FutureMeeting = () =>
    import(/* webpackChunkName: "c2" */ '@/presentations/FutureMeetingGT.vue');
const YearEndMeeting = () =>
    import(/* webpackChunkName: "c2" */ '@/presentations/YearEndMeetingGT.vue');

Vue.use(Router);

const router: Router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Root,
            children: [

                {
                    path: '/print',
                    component: PresentationPrint,
                    children: [
                        {
                            path: '/print/typed/:DocumentId',
                            name: 'presentation-typed-print',
                            components: {main: Presentation},
                        },
                        {
                            path: '/print/company/:DocumentId',
                            name: 'presentation-company-print',
                            components: {main: Presentation},
                        },
                        {
                            path: '/print/competitors/:DocumentId',
                            name: 'presentation-competitors-print',
                            components: {main: Presentation},
                        },
                        {
                            path: '/print/closingmeeting/:DocumentId',
                            name: 'presentation-closingmeeting-print',
                            components: {main: ClosingMeeting},
                        },
                        {
                            path: '/print/preclosingmeeting/:DocumentId',
                            name: 'presentation-preclosingmeeting-print',
                            components: {main: PreClosingMeeting},
                        },
                        {
                            path: '/print/futuremeeting/:DocumentId',
                            name: 'presentation-futuremeeting-print',
                            components: {main: FutureMeeting},
                        },
                        {
                            path: '/print/yearendmeeting/:DocumentId',
                            name: 'presentation-yearendmeeting-print',
                            components: {main: YearEndMeeting},
                        },
                        {
                            path: '/print/yearreview/:DocumentId',
                            name: 'presentation-yearreview-print',
                            components: {main: YearReview},
                        },
                        {
                            path: '/print/deck/:DocumentId',
                            name: 'presentation-deck-print',
                            components: {main: ShowSlides},
                        },
                    ],
                },

                {
                    path: '/pdf',
                    component: PresentationPrint,
                    children: [
                        {
                            path: '/pdf/cashflow/:DocumentId',
                            name: 'pdf-cashflow-print',
                            components: {main: CashflowPdf},
                        },
                        {
                            path: '/pdf/valuation/:DocumentId',
                            name: 'pdf-valuation-print',
                            components: {main: ValuationPdf},
                        },
                        {
                            path: '/pdf/company/:DocumentId',
                            name: 'pdf-company-print',
                            components: {main: CompanyPdf},
                        },
                        {
                            path: '/pdf/notes/:DocumentId',
                            name: 'pdf-notes-print',
                            components: {main: NotesPdf},
                        },
                        {
                            path: '/pdf/kyc/:UserId/:Version/:OrgNr/:SieId',
                            name: 'pdf-kyc-print',
                            components: {main: KycPdf},
                        },
                        {
                            path: '/pdf/sandbox/:DocumentId',
                            name: 'pdf-sandbox-print',
                            components: {main: SandboxPdf},
                        },
                        {
                            path: '/pdf/sustainability/:UserId/:Version/:OrgNr/:SieId',
                            name: 'pdf-sustainability-print',
                            components: {main: SustainabilityPdf},
                        },
                        {
                            path: '/pdf/accounting/:UserId/:Version/:OrgNr/:SieId',
                            name: 'pdf-accounting-print',
                            components: {main: AccountingPdf},
                        },
                    ],
                },

                {
                    path: '/presentation/:DocumentId',
                    component: Presentation,
                    name: 'presentation',
                },
                {
                    path: '/presentation/company/:DocumentId',
                    component: Presentation,
                    name: 'presentation-company',
                },
                {
                    path: '/presentation/cashflow/:DocumentId',
                    component: Presentation,
                    name: 'presentation-cashflow',
                },
                {
                    path: '/presentation/competitors/:DocumentId',
                    component: Presentation,
                    name: 'presentation-competitors',
                },

                {
                    path: '/webreport',
                    component: PresentationPrint,
                    children: [
                        {
                            path: '/webreport/:DocumentId',
                            name: 'webreport',
                            components: {main: CashflowWebreport},
                        },
                    ],
                },

                {
                    path: '/shared',
                    component: PresentationScreen,
                    children: [
                        {
                            path: '/shared/:DocumentId',
                            name: 'presentation-shared',
                            components: {main: ShowSlides},
                        },
                        {
                            path: '/shared/:DocumentId/info',
                            name: 'presentation-shared-info',
                            components: {main: ShowSlidesInfo},
                        },
                    ],
                },

                {
                    path: '/presentation',
                    component: PresentationScreen,
                    children: [
                        {
                            path: '/presentation/quick/:OrgNr',
                            name: 'presentation-quick',
                            components: {main: Quick},
                        },
                        {
                            path: '/presentation/deck/:DocumentId',
                            name: 'presentation-deck',
                            components: {main: ShowSlides},
                        },
                        {
                            path: '/presentation/valuation/:DocumentId',
                            name: 'presentation-valuation',
                            components: {main: Valuation},
                        },
                        // {
                        //   path: '/presentation/company/:DocumentId',
                        //   name: 'presentation-company',
                        //   components: {main: Company},
                        // },
                        // {
                        //     path: '/presentation/competitors/:DocumentId',
                        //     name: 'presentation-competitors',
                        //     components: {main: Competitors},
                        // },
                        {
                            path: '/presentation/closingmeeting/:DocumentId',
                            name: 'presentation-closingmeeting',
                            components: {main: ClosingMeeting},
                        },
                        {
                            path: '/presentation/preclosingmeeting/:DocumentId',
                            name: 'presentation-preclosingmeeting',
                            components: {main: PreClosingMeeting},
                        },
                        {
                            path: '/presentation/futuremeeting/:DocumentId',
                            name: 'presentation-futuremeeting',
                            components: {main: FutureMeeting},
                        },
                        {
                            path: '/presentation/yearendmeeting/:DocumentId',
                            name: 'presentation-yearendmeeting',
                            components: {main: YearEndMeeting},
                        },
                        {
                            path: '/presentation/yearreview/:DocumentId',
                            name: 'presentation-yearreview',
                            components: {main: YearReview},
                        },
                    ],
                },

                {
                    path: '/console',
                    name: 'admin',
                    component: () =>
                        import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
                },

                {
                    path: '/',
                    redirect: '/start',
                    component: MainLayout,
                    children: [
                        {
                            path: '/start',
                            name: 'start',
                            components: {main: Start},
                        },
                        {
                            path: '/portfolio',
                            name: 'portfolio',
                            components: {main: Portfolio, sidebar: SidebarPortfolio},
                        },
                        {
                            path: '/document/edit',
                            name: 'editdocument',
                            components: {main: EditDocument},
                        },
                        {
                            path: '/edit/:DocumentId',
                            name: 'editpresentation',
                            components: {main: CreateSlides},
                        },
                        {
                            path: 'templates/:OrgNr',
                            name: 'templates',
                            components: {main: CardDocuments, sidebar: SidebarCreateDocument, iconbar: Iconbar},
                            props: {main: {kind: 'templates'}},
                        },
                        {
                            path: '/template',
                            name: 'template',
                            components: {main: CreateDocument, sidebar: SidebarCreateDocument},
                            props: {main: {type: 'template'}},
                        },
                        {
                            path: '/template/:TemplateId',
                            name: 'template-based-on',
                            components: {main: CreateDocument, sidebar: SidebarCreateDocument},
                            props: {main: {type: 'template'}},
                        },
                        {
                            path: '/document',
                            name: 'document',
                            components: {main: CreateDocument, sidebar: SidebarCreateDocument},
                            props: {main: {type: 'presentation'}},
                        },
                        {
                            path: '/slidedeck',
                            name: 'slidedeck',
                            components: {main: CreateSlides},
                        },
                        {
                            path: '/importsie',
                            name: 'importsie',
                            components: {main: ImportSie},
                        },
                        {
                            path: '/editsie',
                            name: 'editsie',
                            components: {main: EditSie},
                        },
                        {
                            path: '/search',
                            name: 'search',
                            components: {main: Search},
                        },
                        {
                            path: '/:OrgNr/overview',
                            name: 'overview',
                            // tslint:disable-next-line: max-line-length
                            components: {main: CardOverview, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/overview/people',
                            name: 'overviewpeople',
                            components: {main: CardOverviewPeople, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/overview/tic',
                            name: 'overviewtic',
                            components: {main: CardTic, sidebar: SidebarCompany, iconbar: Iconbar},
                            beforeEnter(to, fromRoute, next) {
                                if (!enableCardTic) {
                                    next({
                                        name: 'overview',
                                        params: {OrgNr: to.params.OrgNr},
                                    });
                                    return;
                                }
                                if (fromRoute !== undefined) {
                                    next();
                                }
                            },
                        },
                        {
                            path: '/:OrgNr/ai-insikter',
                            name: 'aiquestions',
                            components: {main: CardAIQuestions, sidebar: SidebarCompany, iconbar: Iconbar},
                            beforeEnter(to, fromRoute, next) {
                                if (!user.user || user.user.AiInsightsEnabled !== true) {
                                    next({
                                        name: 'overview',
                                        params: {OrgNr: to.params.OrgNr},
                                    });
                                    return;
                                }
                                next();
                            },
                        },
                        {
                            path: '/:OrgNr/compass',
                            name: 'compass',
                            components: {main: CardCompassNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/compass/years',
                            name: 'compassyears',
                            components: {main: CardCompassYearsNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/compass/industry',
                            name: 'compassindustry',
                            components: {main: CardCompassIndustryNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/compass/sustainability',
                            name: 'compasssustainability',
                            components: {main: CardSustainability, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/profitloss/table',
                            name: 'profitlosstable',
                            components: {main: CardProfitLoss, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/profitloss',
                            name: 'profitloss',
                            components: {main: CardProfitLossNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/balance/table',
                            name: 'balancetable',
                            components: {main: CardBalance, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/balance',
                            name: 'balance',
                            components: {main: CardBalanceNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/cashflow',
                            name: 'cashflow',
                            components: {main: CardCashFlowNew, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/cashflow/table',
                            name: 'cashflowtable',
                            components: {main: CardCashFlow, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/cashflow/analysis',
                            name: 'cashflowanalysis',
                            components: {main: CardCashFlowAnalysis, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/valuation',
                            name: 'valuation',
                            components: {main: CardValuation, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/valuation/analysis',
                            name: 'valuationanalysis',
                            components: {main: CardValuationAnalysis, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/sie',
                            name: 'sie',
                            components: {main: CardSie, sidebar: SidebarCompany, iconbar: Iconbar},
                        },
                        {
                            path: '/:OrgNr/documents',
                            name: 'documents',
                            components: {main: CardDocuments, sidebar: SidebarCompany, iconbar: Iconbar},
                            props: {main: {kind: 'documents'}},
                        },
                        // {
                        //     path: '/:OrgNr/sandbox',
                        //     name: 'sandbox',
                        //     components: {main: CardSandbox, sidebar: SidebarCompany},
                        // },
                    ],
                },
            ],
        },
    ],
});

router.beforeEach((to: any, from: any, next: any) => {
    if (user && user.user) {
        axios.defaults.headers.common['X-Userid-Ex'] = user.activeExternalUser
            ? user.activeExternalUser
            : '';
        axios.defaults.headers.common['X-User-Seq'] = user.user.Seq;
    } else {
        axios.defaults.headers.common['X-Userid-Ex'] = '';
        axios.defaults.headers.common['X-User-Seq'] = '';
    }
    // console.log('Route:', to.matched);
    if (to.matched.length > 1 && to.matched[1].path.startsWith('/:OrgNr')) {
        user.resetCompany(to.params.OrgNr);
    }
    return next();
});

export default router;
